<script>
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Switch } from 'buefy/dist/components/switch'
import { Table,TableColumn } from 'buefy/dist/components/table'
import { Tabs,TabItem } from 'buefy/dist/components/tabs'

export default {
    name : "ReportingUnitsView",
    components: {
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-switch' : Switch,
        'b-table' : Table,
        'b-table-column' : TableColumn,
        'b-tabs' : Tabs,
        'b-tab-item' : TabItem
    },
    props: {
        repEntityData : Object
    },
    data(){
        return {
            reportingUnits : [],
            activeTab : 0
        }
    },
    created(){
        console.log(this.repEntityData)
        // Initialize rows
        // if there are existig reporting units
        this.combineUnits();
        this.addRow();
    },
    methods : {
        addRow(){
            this.reportingUnits.push({
                reportingUnit : "",
                isActive : true,
                isNew : true
            });
        },
        combineUnits(){
            // this.repEntityData.reportingUnits.forEach(unit=>{
            //     unit.isNew = false;
            //     this.reportingUnits.push(unit);
            // });
        },
        deleteRow(row){
            this.reportingUnits.splice(row.index,1);
        },
        triggerClose(){
            this.reportingUnits = [];
            this.combineUnits();
            this.$emit('close');
        },
        triggerSubmit(){
            var newUnits = [];
            this.reportingUnits.forEach(unit=>{
                if (unit.isNew==true && unit.reportingUnit.trim()!="") {
                    newUnits.push({
                        reportingUnit: unit.reportingUnit,
                        isActive: unit.isActive,
                        repEntityId : this.repEntityData.repEntityId
                    });
                }
            });
            this.$emit('save-rep-unit',newUnits);
        }
    }
}
</script>

<template>
    <div class="box">
        <p class="heading">{{repEntityData.reportingEntity}}</p>
        <h1 class="title is-4">Reporting Units</h1>

        <div class="content">
            
            <!-- Existing Units -->
            <div class="table-wrapper">
                <b-table
                    v-bind:data="repEntityData.reportingUnits ? repEntityData.reportingUnits : []">
                    <template
                        slot-scope="props">
                        <b-table-column
                            field="reportingUnit"
                            label="Unit Name">
                            {{props.row.reportingUnit}}
                        </b-table-column>

                        <b-table-column
                            field="isActive"
                            label="Active"
                            width="100">
                            {{props.row.isActive==true ? "Yes" : "No" }}
                        </b-table-column>
                    </template>
                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                    <b-icon
                                        icon="emoticon-sad"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <p>No data available.</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </div>

            <!-- For New Units -->
            <div class="table-wrapper">
                <b-table
                    v-bind:data="reportingUnits">
                    <template
                        slot-scope="props">
                        <b-table-column
                            field=""
                            label="Option">
                            <button
                                class="button is-white"
                                type="button"
                                v-on:click="deleteRow(props)">
                                <span class="icon">
                                    <i class="fas fa-trash"></i>
                                </span>
                            </button>
                        </b-table-column>

                        <b-table-column
                            field="reportingUnit"
                            label="New Unit">
                            <b-field>
                                <b-input 
                                    v-model="props.row.reportingUnit"
                                    type="text"
                                    value=""
                                    required></b-input>
                            </b-field>
                        </b-table-column>

                        <b-table-column
                            field="isActive"
                            label="Active"
                            width="100">
                            <b-field>
                                <b-switch v-model="props.row.isActive">
                                    {{props.row.isActive==true ? "Yes" : "No" }}
                                </b-switch>
                            </b-field>
                        </b-table-column>
                    </template>
                </b-table>
            </div>

            <div class="columns">
                <div class="column has-text-left">
                    <a class="button is-text"
                        v-on:click="addRow">
                        <span>+ Add Row</span>
                    </a>
                </div>
                <div class="column has-text-right">
                    <a class="button is-light"
                        v-on:click="triggerClose">
                        <span>Cancel</span>
                    </a>
                    
                    <a class="button is-success"
                        v-on:click="triggerSubmit">
                        <span>Submit New Unit/s</span>
                    </a>
                    &nbsp;&nbsp;&nbsp;
                </div>
            </div>

            <br />
        </div>
    </div>
</template>

<style scoped>
.table-wrapper {
    min-height: 180px;
    border-radius: 3px;
    box-sizing: border-box;
    padding: 0.45em;
}

.b-table {
    border:1px solid #e5e5e5;
}

.new-units-form-wrapper {
    border-radius: 3px;
    box-sizing: border-box;
    padding: 0.45em;
    border:1px solid #e5e5e5;
}
</style>





// WEBPACK FOOTER //
// src/views/administration/ReportingUnitsView.vue